module.exports = __webpack_public_path__ + "img/BJT.be2f9fbe.png";